// extracted by mini-css-extract-plugin
module.exports = {"container":"artist_container__2TTv2","artistInfo":"artist_artistInfo__2NiU5","tableContainer":"artist_tableContainer__2nSCS"};